/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InvoiceBulkRegenerateInvoicesForCourierRequest
 */
export interface InvoiceBulkRegenerateInvoicesForCourierRequest {
    /**
     * 
     * @type {string}
     * @memberof InvoiceBulkRegenerateInvoicesForCourierRequest
     */
    courierId?: string;
    /**
     * 
     * @type {number}
     * @memberof InvoiceBulkRegenerateInvoicesForCourierRequest
     */
    skip?: number;
    /**
     * 
     * @type {number}
     * @memberof InvoiceBulkRegenerateInvoicesForCourierRequest
     */
    limit?: number;
}

/**
 * Check if a given object implements the InvoiceBulkRegenerateInvoicesForCourierRequest interface.
 */
export function instanceOfInvoiceBulkRegenerateInvoicesForCourierRequest(value: object): value is InvoiceBulkRegenerateInvoicesForCourierRequest {
    return true;
}

export function InvoiceBulkRegenerateInvoicesForCourierRequestFromJSON(json: any): InvoiceBulkRegenerateInvoicesForCourierRequest {
    return InvoiceBulkRegenerateInvoicesForCourierRequestFromJSONTyped(json, false);
}

export function InvoiceBulkRegenerateInvoicesForCourierRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvoiceBulkRegenerateInvoicesForCourierRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'courierId': json['courierId'] == null ? undefined : json['courierId'],
        'skip': json['skip'] == null ? undefined : json['skip'],
        'limit': json['limit'] == null ? undefined : json['limit'],
    };
}

export function InvoiceBulkRegenerateInvoicesForCourierRequestToJSON(json: any): InvoiceBulkRegenerateInvoicesForCourierRequest {
    return InvoiceBulkRegenerateInvoicesForCourierRequestToJSONTyped(json, false);
}

export function InvoiceBulkRegenerateInvoicesForCourierRequestToJSONTyped(value?: InvoiceBulkRegenerateInvoicesForCourierRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'courierId': value['courierId'],
        'skip': value['skip'],
        'limit': value['limit'],
    };
}

